import { z } from 'zod'
import { LearningStatus } from '@/core/domain/resources/enums/LearningStatus'
import {
  LearningGrainListSchema,
  LearningGrainSchema
} from '@/core/infrastructure/schemas/learning/grain/LearningGrainSchema'
import { QuizSchema } from '@/core/infrastructure/schemas/quiz/QuizSchema.ts'
import { orderBy } from 'lodash'
import { ReferentialTask } from '@/core/domain/referential/task/ReferentialTask.ts'
import { ReferentialTaskSchema } from '@/core/infrastructure/schemas/referential/task/ReferentialTaskSchema.ts'

// Schema de base pour un module d'apprentissage
export const LearningModuleSchema = z.object({
  id: z.number(),
  title: z.string(),
  status: z.nativeEnum(LearningStatus.Values),
  order: z.number(),
  task: ReferentialTaskSchema.optional(),
  learningCourseId: z.number(),
  learningCourseName: z.string(),
  learningGrains: z.array(LearningGrainSchema).optional(),
  createdBy: z.string().optional(),
  createdAt: z.string().datetime().optional(),
  modifiedBy: z.string().optional(),
  modifiedAt: z.string().datetime().optional()
})

// Liste de modules
export const LearningModuleListSchema = z.array(LearningModuleSchema)

// Entrée pour la création ou la mise à jour d'un module
export const LearningModuleInputSchema = z.object({
  id: z.number(),
  title: z.string(),
  order: z.number(),
  status: z.nativeEnum(LearningStatus.Values),
  taskId: z.number().optional(),
  learningGrains: z.array(LearningGrainSchema).optional()
})

// Types dérivés des schemas
export type LearningModuleEntity = z.infer<typeof LearningModuleSchema>
export type LearningModuleListEntity = z.infer<typeof LearningModuleListSchema>
export type LearningModuleInputEntity = z.infer<typeof LearningModuleInputSchema>
